// extracted by mini-css-extract-plugin
export default {"GitHub":"GitHub_GitHub__Igi4f"};